<div class="create-goods-modal">
  <form class="create-goods-modal__form" [formGroup]="formModel.form" (ngSubmit)="submitForm()">
    @let formInteracted = formModel.form.dirty || formModel.form.touched;
    <section class="create-goods-modal__panel">
      <div class="create-goods-modal__grid">
        <div class="create-goods-modal__field">
          <label class="form-label required" for="goods-number">
            {{ 'COMPONENTS.GOODS.FIELDS.NUMBER' | translate }}
          </label>
          @let numberControl = formModel.form.controls.number;
          <input
            id="goods-number"
            type="text"
            class="form-input"
            [class.is-invalid]="formInteracted && numberControl.errors"
            [class.is-valid]="formInteracted && !numberControl.errors"
            [formControlName]="formModel.fieldNames.number"
          />
          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: numberControl.errors, showErrors: formInteracted }"
          ></ng-container>
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label required" for="goods-name">
            {{ 'COMPONENTS.GOODS.FIELDS.DISPLAY_NAME' | translate }}
          </label>
          @let displayNameControl = formModel.form.controls.displayName;
          <input
            id="goods-name"
            type="text"
            class="form-input"
            [class.is-invalid]="formInteracted && displayNameControl.errors"
            [class.is-valid]="formInteracted && !displayNameControl.errors"
            [formControlName]="formModel.fieldNames.displayName"
          />
          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: displayNameControl.errors, showErrors: formInteracted }"
          ></ng-container>
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label" for="goods-name2">
            {{ 'COMPONENTS.GOODS.FIELDS.DISPLAY_NAME_2' | translate }}
          </label>
          <input id="goods-name2" type="text" class="form-input" [formControlName]="formModel.fieldNames.displayName2" />
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label" for="goods-gtin">
            {{ 'COMPONENTS.GOODS.FIELDS.GTIN' | translate }}
          </label>
          <input id="goods-gtin" type="text" class="form-input" [formControlName]="formModel.fieldNames.gtin" />
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label" for="goods-category">
            {{ 'COMPONENTS.GOODS.FIELDS.CATEGORY' | translate }}
          </label>
          <select id="goods-category" class="form-input" [formControlName]="formModel.fieldNames.goodsCategoryId">
            <option [ngValue]="null">{{ 'COMPONENTS.GOODS.CATEGORY_PLACEHOLDER' | translate }}</option>
            @for (category of categoryOptions; track category.id) {
              <option [value]="category.id">{{ category.label }}</option>
            }
          </select>
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label required" for="goods-type">
            {{ 'COMPONENTS.GOODS.FIELDS.ITEM_TYPE' | translate }}
          </label>
          @let itemTypeControl = formModel.form.controls.itemType;
          <select
            id="goods-type"
            class="form-input"
            [class.is-invalid]="formInteracted && itemTypeControl.errors"
            [class.is-valid]="formInteracted && !itemTypeControl.errors"
            [formControlName]="formModel.fieldNames.itemType"
          >
            @for (option of itemTypeOptions; track option.value) {
              <option [value]="option.value">{{ option.labelKey | translate }}</option>
            }
          </select>
          <ng-container
            [ngTemplateOutlet]="validationErrorsTemplate"
            [ngTemplateOutletContext]="{ errors: itemTypeControl.errors, showErrors: formInteracted }"
          ></ng-container>
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label" for="goods-status">
            {{ 'COMPONENTS.GOODS.FIELDS.STATUS' | translate }}
          </label>
          <select id="goods-status" class="form-input" [formControlName]="formModel.fieldNames.status">
            <option [ngValue]="0">{{ 'INVENTORY_ITEM_STATUSES.ACTIVE' | translate }}</option>
            <option [ngValue]="1">{{ 'INVENTORY_ITEM_STATUSES.BLOCKED' | translate }}</option>
          </select>
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label" for="goods-manufacturer">
            {{ 'COMPONENTS.GOODS.FIELDS.MANUFACTURER' | translate }}
          </label>
          <input id="goods-manufacturer" type="text" class="form-input" [formControlName]="formModel.fieldNames.manufacturer" />
        </div>

        <div class="create-goods-modal__field">
          <label class="form-label" for="goods-model">
            {{ 'COMPONENTS.GOODS.FIELDS.MODEL' | translate }}
          </label>
          <input id="goods-model" type="text" class="form-input" [formControlName]="formModel.fieldNames.model" />
        </div>

        <div class="create-goods-modal__inline-row md:col-span-2">
          <div class="create-goods-modal__field">
            <label class="form-label required" for="goods-price">
              {{ 'COMPONENTS.GOODS.FIELDS.UNIT_PRICE' | translate }}
            </label>
            @let unitPriceControl = formModel.form.controls.unitPrice;
            <input
              id="goods-price"
              type="number"
              class="form-input"
              [class.is-invalid]="formInteracted && unitPriceControl.errors"
              [class.is-valid]="formInteracted && !unitPriceControl.errors"
              [formControlName]="formModel.fieldNames.unitPrice"
            />
            <ng-container
              [ngTemplateOutlet]="validationErrorsTemplate"
              [ngTemplateOutletContext]="{ errors: unitPriceControl.errors, showErrors: formInteracted }"
            ></ng-container>
          </div>

          <div class="create-goods-modal__field">
            <label class="form-label required" for="goods-cost">
              {{ 'COMPONENTS.GOODS.FIELDS.UNIT_COST' | translate }}
            </label>
            @let unitCostControl = formModel.form.controls.unitCost;
            <input
              id="goods-cost"
              type="number"
              class="form-input"
              [class.is-invalid]="formInteracted && unitCostControl.errors"
              [class.is-valid]="formInteracted && !unitCostControl.errors"
              [formControlName]="formModel.fieldNames.unitCost"
            />
            <ng-container
              [ngTemplateOutlet]="validationErrorsTemplate"
              [ngTemplateOutletContext]="{ errors: unitCostControl.errors, showErrors: formInteracted }"
            ></ng-container>
          </div>

          <div class="create-goods-modal__field">
            <label class="form-label" for="goods-currency">
              {{ 'COMPONENTS.GOODS.FIELDS.CURRENCY' | translate }}
            </label>
            <select
              id="goods-currency"
              class="form-input"
              [formControlName]="formModel.fieldNames.currencyCode"
            >
              <option value="UAH">UAH</option>
              <option value="EUR">EUR</option>
              <option value="USD">USD</option>
            </select>
          </div>

          <div class="create-goods-modal__field">
            <label class="form-label required" for="goods-unit">
              {{ 'COMPONENTS.GOODS.FIELDS.UNIT' | translate }}
            </label>
            @let baseUnitControl = formModel.form.controls.baseUnitOfMeasureId;
            <select
              id="goods-unit"
              class="form-input"
              [class.is-invalid]="formInteracted && baseUnitControl.errors"
              [class.is-valid]="formInteracted && !baseUnitControl.errors"
              [formControlName]="formModel.fieldNames.baseUnitOfMeasureId"
            >
              <option [ngValue]="null">{{ 'COMPONENTS.GOODS.UNIT_PLACEHOLDER' | translate }}</option>
              @for (unit of unitOfMeasureOptions; track unit.id) {
                <option [ngValue]="unit.id">{{ unit.displayName }}</option>
              }
            </select>
            <ng-container
              [ngTemplateOutlet]="validationErrorsTemplate"
              [ngTemplateOutletContext]="{ errors: baseUnitControl.errors, showErrors: formInteracted }"
            ></ng-container>
          </div>
        </div>
      </div>

      <label class="create-goods-modal__checkbox mt-4 flex cursor-pointer items-center gap-3 rounded-2xl px-4 py-3 text-sm">
        <input type="checkbox" class="h-4 w-4" [formControlName]="formModel.fieldNames.priceIncludesTax" />
        <span>{{ 'COMPONENTS.GOODS.FIELDS.PRICE_INCLUDES_TAX' | translate }}</span>
      </label>

      @if (isLoadingCategories) {
        <p class="mt-3 text-xs text-slate-500 dark:text-slate-300">
          {{ 'MESSAGES.LOADING' | translate }}
        </p>
      }
    </section>

    <div class="create-project-actions create-goods-modal__actions">
      <button type="button" class="form-secondary-btn" (click)="onCancel()">
        {{ 'BUTTONS.CANCEL' | translate }}
      </button>

      <button type="submit" class="form-primary-btn" [disabled]="formModel.form.invalid || isSubmitting">
        {{ 'BUTTONS.CREATE' | translate }}
      </button>
    </div>
  </form>
</div>

<ng-template #validationErrorsTemplate let-errors="errors" let-showErrors="showErrors">
  @if (showErrors && errors) {
    <ul class="invalid-feedback">
      @if (errors['required']) {
        <li>{{ 'ERRORS.REQUIRED' | translate }}</li>
      }
      @if (errors['maxlength']; as maxLengthError) {
        <li>{{ 'ERRORS.MAXLENGTH' | translate: { requiredLength: maxLengthError.requiredLength } }}</li>
      }
    </ul>
  }
</ng-template>
